export default "__VITE_ASSET__CcxorkUz__"